import { FavoritesContainer } from "./FavoritesContainer";
import { Wrapper } from "../mobile/screens/TicketsScreen/TicketsScreen.styles";
import { useCurrentBreakpointName } from "react-socks";
import { useHistory, useLocation } from "react-router";
import Header from "../desktop/components/Header";
import React from "react";
import { useAuth } from "hooks/useAuth";
import { TemporaryUserInfo } from "views/components/TemporaryUserInfo";

const Favorites = () => {
	const history = useHistory();
	const location = useLocation();
	const { isLoggedInTemporary } = useAuth();

	const currentBp = useCurrentBreakpointName();

	const routesForDesktop = ["/home", "/", "/favorites"];
	const desktop =
		routesForDesktop.includes(location.pathname) && currentBp === "desktop";
	return desktop ? (
		<FavoritesContainer></FavoritesContainer>
	) : (
		<>
			<Wrapper>
				<Header
					transparent
					fg="fg_alt"
					title="Favoritos"
					goBack={history.goBack}
				/>
				<h1>Favoritos</h1>
				<p style={{ padding: "10px" }}>
					Agrega a tus favoritos las oficinas que visites con más
					frecuencia.
				</p>
			</Wrapper>

			{!isLoggedInTemporary && <FavoritesContainer></FavoritesContainer>}
			{isLoggedInTemporary && (
				<TemporaryUserInfo isLoggedInTemporary={isLoggedInTemporary} />
			)}
		</>
	);
};

export { Favorites };
